const MANAGED_PROJECT_TREE_FOLDER_DEFINITIONS = [
    {
        systemKey: "presentation-layer",
        defaultName: "Presentation Layer",
        defaultParentFrameworkNodeKey: "solution-root",
    },
];
const MANAGED_PROJECT_TREE_FOLDER_DEFINITION_BY_SYSTEM_KEY = new Map(MANAGED_PROJECT_TREE_FOLDER_DEFINITIONS.map((definition) => [definition.systemKey, definition]));
export function listManagedProjectTreeFolderDefinitions() {
    return [...MANAGED_PROJECT_TREE_FOLDER_DEFINITIONS];
}
export function getManagedProjectTreeFolderDefinition(systemKey) {
    return MANAGED_PROJECT_TREE_FOLDER_DEFINITION_BY_SYSTEM_KEY.get(systemKey) ?? null;
}
